var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18548",
    transform: "translate(-480 -608)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 995",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(480 608)",
    style: {
      fill: "#ffd9a7"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56961",
    d: "M518.879 628.34v-2.256a1.085 1.085 0 1 0-2.169 0v2.166h-9.393v-2.166a1.085 1.085 0 1 0-2.169 0v2.256c-3.9.361-5.8 2.689-6.087 6.145a.726.726 0 0 0 .723.766h24.459a.717.717 0 0 0 .723-.766c-.289-3.455-2.183-5.783-6.087-6.145z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56962",
    d: "M523.578 637.419h-23.132a1.45 1.45 0 0 0-1.446 1.446v8.906c0 4.337 2.169 7.229 7.229 7.229H517.8c5.06 0 7.229-2.892 7.229-7.229v-8.906a1.45 1.45 0 0 0-1.451-1.446zm-15.6 12.1a2.278 2.278 0 0 1-.217.173 1.1 1.1 0 0 1-.26.13.919.919 0 0 1-.26.087 1.959 1.959 0 0 1-.289.029 1.439 1.439 0 0 1-.549-.116 1.493 1.493 0 0 1-.477-.3 1.466 1.466 0 0 1 0-2.053 1.492 1.492 0 0 1 .477-.3 1.382 1.382 0 0 1 .839-.087.919.919 0 0 1 .26.087 1.1 1.1 0 0 1 .26.13l.217.173a1.466 1.466 0 0 1 0 2.053zm0-5.06a1.452 1.452 0 0 1-2.053-2.053 1.444 1.444 0 0 1 1.576-.3 1.349 1.349 0 0 1 .477.3 1.466 1.466 0 0 1 0 2.053zm5.06 5.06a1.466 1.466 0 1 1 .419-1.027 1.52 1.52 0 0 1-.419 1.028zm0-5.06-.217.173a1.1 1.1 0 0 1-.26.13.919.919 0 0 1-.26.087 1.959 1.959 0 0 1-.289.029 1.452 1.452 0 0 1-1.026-2.472 1.349 1.349 0 0 1 .477-.3 1.444 1.444 0 0 1 1.576.3 1.466 1.466 0 0 1 0 2.053zm5.06 5.06a1.466 1.466 0 1 1 .419-1.027 1.52 1.52 0 0 1-.417 1.028zm0-5.06-.217.173a1.1 1.1 0 0 1-.26.13.919.919 0 0 1-.26.087 2.173 2.173 0 0 1-.289.029 1.452 1.452 0 0 1-1.027-2.472 1.492 1.492 0 0 1 .477-.3 1.382 1.382 0 0 1 .839-.087.919.919 0 0 1 .26.087 1.1 1.1 0 0 1 .26.13l.217.173a1.466 1.466 0 0 1 0 2.053z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepayment);
export default __webpack_public_path__ + "static/media/repayment.fc58d0b40707add4aaebb93f80c165da.svg";
export { ForwardRef as ReactComponent };